import * as Yup from 'yup';
import i18n from 'i18next';
import STRING_KEYS from '../../language/keys';

export const initialValues = {
  email: '',
  password: '',
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  errorMessage: null,
};

export const validationSchema = Yup.object({
  email: Yup
    .string()
    .email(i18n.t(STRING_KEYS.LOGIN_EMAIL_VALIDATION))
    .max(255)
    .required(i18n.t(STRING_KEYS.LOGIN_EMAIL_REQUIRED_VALIDATION)),
  password: Yup
    .string()
    .max(255)
    .required(i18n.t(STRING_KEYS.LOGIN_PASSWORD_REQUIRED_VALIDATION)),
});
